<template>
    <b-card class="small-vehicle-card">
        <div class="card-img-wrapper d-flex justify-content-center">
            <vehicle-image
                :body-style="vehicle.bodyType"
                :vehicle-name="vehicleName"
                :vehicle-image-url="vehicleImageUrl"
                class="card-img"
            />
        </div>
        <div
            class="d-flex flex-column justify-content-sm-end justify-content-between h-100 w-100"
        >
            <h5 class="d-sm-none">
                <span class="yearMake">
                    {{ vehicle.year }} {{ vehicle.make }} </span
                ><br />
                {{ vehicle.model }} {{ vehicle.trim }}
            </h5>
            <h5 class="d-sm-block d-none text-center">
                <span class="yearMakeModel">
                    {{ vehicle.year }} {{ vehicle.make }}
                    {{ vehicle.model }} </span
                ><br />
                {{ vehicle.trim }}
            </h5>
            <div
                class="d-flex justify-content-between d-sm-none price-blocks flex-wrap"
            >
                <price-block label="Base Price" :value="vehicle.msrp" />
                <price-block label="Options" :value="optionsCost" add-plus />
                <price-block
                    label="Total"
                    :value="vehicle.msrp + optionsCost"
                    variant="blue"
                />
            </div>
        </div>
    </b-card>
</template>

<style lang="scss">
.small-vehicle-card {
    background-color: $very-light-gray;
    color: $dark-gray;
    border: none;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);

    .card-img-wrapper {
        margin-right: 15px;
        text-align: center;

        img {
            height: 100%;
            width: fit-content;
            max-width: 120px;
        }
    }

    .price-blocks {
        .price-block {
            font-size: 10px;

            span {
                font-size: 14px;
            }
        }
    }

    @include media-breakpoint-down(sm) {
        .card-img-wrapper {
            i {
                font-size: 40px;
                margin: 20px 0;
            }
        }
    }

    @include media-breakpoint-up(md) {
        box-shadow: none;
        background-color: #fff;
        padding-bottom: 15px;

        .card-img-wrapper {
            img {
                max-width: 250px;
            }
        }
    }

    .card-body {
        padding: 0.7rem 1.25rem;
        display: flex;
        justify-content: space-between;
        flex-direction: row;

        @include media-breakpoint-up(md) {
            flex-direction: column;
        }
    }

    h5 {
        font-weight: normal;
        font-size: 16px;
        border-bottom: solid 1px $light-medium-gray;
        padding-bottom: 0.5rem;

        .yearMake {
            font-size: 10px;
            font-weight: 300;
        }

        @include media-breakpoint-up(md) {
            font-size: 16px;
            border: none;

            .yearMakeModel {
                font-family: $helvetica-55-Roman;
                font-size: 18px;
            }
        }
    }
}
</style>

<script>
import api from "@/api";
import PriceBlock from "./PriceBlock";
import _ from "lodash";
import VehicleImage from "../../components/VehicleImage";

export default {
    name: "VehicleCard",

    components: {
        VehicleImage,
        "price-block": PriceBlock
    },

    props: {
        vehicle: {
            type: Object,
            required: true
        },
        optionsCost: {
            type: Number,
            required: false,
            default: 0
        },
        exteriorColorCode: {
            type: String,
            required: false,
            default: null
        }
    },

    data() {
        return {
            vehicleImageUrl: null
        };
    },

    computed: {
        vehicleName() {
            return `${this.vehicle.year} ${this.vehicle.make} ${this.vehicle.model}`;
        }
    },

    watch: {
        exteriorColorCode(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.updateVehicleImageUrl();
            }
        }
    },

    mounted() {
        this.updateVehicleImageUrl();
    },

    methods: {
        updateVehicleImageUrl() {
            if (_.isNil(this.exteriorColorCode)) {
                return;
            }

            const size = window.innerWidth < 768 ? "WIDTH_640" : "WIDTH_320";
            const background =
                window.innerWidth < 768 ? "TRANSPARENT" : "WHITE";

            const request = {
                type: "PROFILE",
                size,
                exteriorColorCode: this.exteriorColorCode,
                background
            };

            return api
                .post(
                    `/vehicle-data/styles/${this.vehicle.styleId}/image`,
                    request
                )
                .then(response => {
                    this.vehicleImageUrl = _.get(response, "data[0].url");
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
};
</script>
